
import { Options, Vue } from "vue-class-component"; //基本需要\

import roma from "../assets/json1/roma.js";
import * as echarts from "echarts";
import passion1 from "@/assets/js/passion1.js";
import { store } from "@/store"; //引入仓库
import { ElMessage } from "element-plus";
import {
  dateConversion,
  getLocalProject,
  saveLocalProject,
  saveLocalStorageProject,
  typeConversion,
} from "@/utils"; //类型
import {
  dispatchGetDeepPerformanceDetails,
  dispatchGetDeepPerformanceStack,
} from "@/store/performance/actions";
import {
  readDeepPerformanceDetails,
  readDeepPerformanceStack,
} from "@/store/performance/getters";
export default class TestReport extends Vue {
  // 获取默认数据
  public get details_list() {
    let list: any = [];
    list = [
      { label: "func_name", prop: "func_name" },
      { label: "Time(ms)", prop: "TimeMs" },
      { label: "Time(%)", prop: "TimeRatio" },
    ];
    return list;
  }
  public frame = this.details_data?.rows?.Frame[0];
  public loading = false;
  public get details_data() {
    const data = readDeepPerformanceDetails(store);
    return data;
  }
  get id() {
    return this.$route.query.id;
  }
  public tableRowClassName(row: any) {
    let num = row.row.TimeRatio * 10;
    var startColor = "#3E3E3E";
    var endColor = "#6E2F2F";
    var colorArr = this.gradient(startColor, endColor, 1000);
    if (num == 1000) {
      num = 999;
    }
    return {
      background: colorArr[num],
      borderBottom: "0",
      color: "#fff",
      height: "2px",
    };
  }
  public b: any = [];
  //   public  table_data(){
  //     this.loading=true
  //      let tableList:any=[]
  //    let readerDeepData:any=  dispatchGetDeepPerformanceStack(store,{
  //       project:this.localProject,
  //       id_test:Number(this.id),
  //       frame:this.details_data?.rows?.Frame[0],
  //       level:1,
  //       func_hash:'',
  //     })
  //    tableList=readerDeepData.func_list

  //     // else{
  //     //   dispatchGetDeepPerformanceStack(store,{
  //     //   project:this.localProject,
  //     //   id_test:Number(this.id),
  //     //   frame:this.frame,
  //     //   level:1,
  //     //   func_hash:'',

  //     // })
  //     // tableList=readDeepPerformanceStack(store).func_list
  //     // }

  //       if(tableList!=undefined){
  // tableList.forEach(function(v:any,index:any){
  //   v.children=[{}]
  //   v.id=(index+=1)
  // })
  // console.log(tableList)
  //      }
  //     this.loading=false
  //      return tableList
  //   }

  public n(row: any) {
    console.log(row);
    if (row.id == 3) {
      this.test = [
        {
          id: 40,
          date: "2016-05-02",
          name: "wangxiaohu",
        },
      ];
    }
  }
  public tableData = [
    {
      id: 1,
      date: "2016-05-02",
      name: "wangxiaohu",
    },
    {
      id: 2,
      date: "2016-05-04",
      name: "wangxiaohu",
    },
    {
      id: 3,
      date: "2016-05-01",
      name: "wangxiaohu",
      is_expand: true,
    },
    {
      id: 4,
      date: "2016-05-03",
      name: "wangxiaohu",
      is_expand: true,
    },
  ];
  public containsDuplicate(nums: any) {
    for (let k = 0; k < nums.length; k++) {
      for (let n = k + 1; n < nums.length; n++) {
        if (nums[k] == nums[n]) return true;
      }
    }
    return false;
  }

  public allList: any = [];
  // public async  c(row:any){
  //  this.tableList.forEach(function(v:any,index:any){
  //     v.level=1
  //     v.id=(index+=1)
  //    })
  //       this.test1=[{
  //     'Time(%)': 4.9,
  // 'Time(ms)': 18.83,
  // 'func_hash': "964138203",
  // 'func_name': "CPU Stall - Wait For Event",
  // 'is_expand': false,
  //   },]
  //      let childrenList= dispatchGetDeepPerformanceStack(store, {
  //       project: this.localProject,
  //       id_test: Number(this.id),
  //       frame: this.frame,
  //       level: Number(row.level),
  //       func_hash: Number(row.func_hash),
  //     });
  //     let childrenListArray:any=[]
  //     await childrenList.then((res: any) => childrenListArray=res);
  //     childrenListArray.func_list.forEach(function(v:any,index:any){
  //       v.level=childrenListArray.level
  //       v.id=(index+=10)*childrenListArray.level+v.func_hash
  //     })
  //     console.log(childrenListArray)
  //     this.test1=childrenListArray.func_list
  //     console.log(this.test1)

  //  console.log(row)
  // }

  //   public async handleDetail(row: any) {

  //         this.allList.push(row)
  //   console.log(this.containsDuplicate(this.allList))

  //       if(this.allList.filter((v:any)=>v==row).length>=2){
  //          if(row.children.length==0){
  //  ElMessage('暂无数据')
  //  return
  //  }

  //       }else{
  //          row.children=[]
  //     console.log( this.frame)
  //     this.tableList.forEach(function(v:any,index:any){
  //       v.level=1
  //       v.id=(index+=1)
  //      })
  //      console.log(row)
  //     let childrenList= dispatchGetDeepPerformanceStack(store, {
  //       project: this.localProject,
  //       id_test: Number(this.id),
  //       frame: this.frame,
  //       level: Number(row.level),
  //       func_hash: Number(row.func_hash),
  //     });
  //     let childrenListArray:any=[]
  //     await childrenList.then((res: any) => childrenListArray=res);
  //     console.log(childrenListArray)
  //     childrenListArray.func_list.forEach(function(v:any,index:any){
  //       v.level=childrenListArray.level
  //       v.id=(index+=10)*childrenListArray.level+v.func_hash
  //         row.children.push(v)
  //     })
  //     if(row.children.length==0){
  //  ElMessage('暂无数据')
  //     }

  //     this.b.push(String(row.id))
  //     console.log(this.b)

  //     console.log(this.tableList)

  //       }

  //   }
  public rgbToHex(r: any, g: any, b: any) {
    var hex = ((r << 16) | (g << 8) | b).toString(16);
    return "#" + new Array(Math.abs(hex.length - 7)).join("0") + hex;
  }
  public hexToRgb(hex) {
    var rgb = [];
    for (var i = 1; i < 7; i += 2) {
      rgb.push(parseInt("0x" + hex.slice(i, i + 2)));
    }
    return rgb;
  }
  public gradient(startColor, endColor, step) {
    // 将 hex 转换为rgb
    var sColor = this.hexToRgb(startColor),
      eColor = this.hexToRgb(endColor);

    // 计算R\G\B每一步的差值
    var rStep = (eColor[0] - sColor[0]) / step;
    var gStep = (eColor[1] - sColor[1]) / step;
    var bStep = (eColor[2] - sColor[2]) / step;

    var gradientColorArr = [];
    for (var i = 0; i < step; i++) {
      // 计算每一步的hex值
      gradientColorArr.push(
        this.rgbToHex(
          parseInt(rStep * i + sColor[0]),
          parseInt(gStep * i + sColor[1]),
          parseInt(bStep * i + sColor[2])
        )
      );
    }
    return gradientColorArr;
  }
  public childrenListArray: any = [];
  public async load(
    row: any,
    treeNode: unknown,
    resolve: (date: any[]) => void
  ) {
    this.tableList.forEach(function (v: any, index: any) {
      v.level = 1;
      v.id = index + 1;
    });
    //       this.test1=[{
    //     'Time(%)': 4.9,
    // 'Time(ms)': 18.83,
    // 'func_hash': "964138203",
    // 'func_name': "CPU Stall - Wait For Event",
    // 'is_expand': false,
    //   },]
    let childrenList = dispatchGetDeepPerformanceStack(store, {
      project: this.localProject,
      id_test: Number(this.id),
      frame: this.frame,
      level: Number(row.level),
      func_hash: Number(row.func_hash),
    });
    // let childrenListArray: any = [];
    await childrenList.then((res: any) => (this.childrenListArray = res));
    await this.childrenListArray.func_list.forEach((v: any, index: any) => {
      v.level = this.childrenListArray.level;
      v.id = (index += 10) * this.childrenListArray.level + v.func_hash;
    });

    await setTimeout(() => {
      resolve(this.childrenListArray?.func_list);
    }, 1000);
  }
  public test: any = [];
  public test1: any = [];
  public load1(row: any, treeNode: unknown, resolve: (date: any[]) => void) {
    setTimeout(() => {
      resolve(this.test);
    });
  }
  public tableList = [];
  public localProject = Number(getLocalProject()); //得到本地的项目
  public async mounted() {
    const project = Number(this.$route.query.project);
    await dispatchGetDeepPerformanceDetails(store, {
      project: this.localProject,
      id_test: Number(this.id),
    });
    // this.table_data()
    await this.details_data;
    this.frame = this.details_data?.rows?.Frame[0];
    let readerDeepData: any = dispatchGetDeepPerformanceStack(store, {
      project: this.localProject,
      id_test: Number(this.id),
      frame: "",
      level: 1,
      func_hash: "",
    });

    await readerDeepData.then((res: any) => (this.tableList = res.func_list));
    this.tableList.forEach(function (v: any, index: any) {
      v.id = index += 1;
    });
    var startColor = "#3E3E3E";
    var endColor = "#6E2F2F";
    var colorArr = this.gradient(startColor, endColor, 1000);

    this.drawDmo();
  }

  public drawDmo() {
    echarts.registerTheme("passion1", passion1);
    var chartDom = document.getElementById("dmo") as HTMLElement;
    var myChart = echarts.init(chartDom, "passion1");
    let series: any = [];
    for (let item in this.details_data.rows) {
      series.push({
        name: item,
        type: "line",
        showSymbol: false,
        data: this.details_data?.rows[item]
          ? this.details_data?.rows[item]
          : [],
        lineStyle: {
          normal: {
            type: "solid",
          },
        },
        markLine: {
          symbol: "none",
          label: {
            position: "end",
          },
          data: [
            {
              // symbol:"block",
              silent: false, //鼠标悬停事件  true没有，false有
              lineStyle: {
                //警戒线的样式  ，虚实  颜色
                type: "solid",
                color: "red",
                width: 3,
              },
              label: {
                position: "end",
                formatter: "阈值",
                color: "#fff",
              },
              yAxis: this.details_data.threshold, // 警戒线的标注值，可以有多个yAxis,多条警示线   或者采用   {type : 'average', name: '平均值'}，type值有  max  min  average，分为最大，最小，平均值
            },
          ],
        },
        hoverAnimation: false,
      });
    }
    let newSeries = series.filter(
      (v: any) => v.name != "timeline" && v.name != "Frame"
    );

    let option;
    option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          // 坐标轴指示器，坐标轴触发有效
          type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          lineStyle: {
            color: "#fff",
            width: 4,
          },
        },
      },
      legend: {
        type: "scroll",
        y: "bottom",
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "20%",
        top: "10%",
        containLabel: true,
      },
      yAxis: {
        type: "value",
      },
      toolbox: {
        feature: {
          saveAsImage: {},
        },
      },
      // dataZoom: [
      //             {
      //               start: 0,
      //               end: 100,
      //               type: 'slider',
      //               // maxValueSpan: 8,
      //               show: true,
      //               yAxisIndex: [0],
      //               handleSize: 0,
      //               // height: '90%',
      //               // left: '100%',
      //               // right: 10,
      //               // top: '4%',
      //               // borderColor: '#005e79',
      //               // radiusAxisIndex: 10,
      //               // fillerColor: '#009ecb',
      //               // backgroundColor: '#005e79',
      //               // showDataShadow: false,
      //               // showDetail: false,
      //               // realtime: true,
      //               // zoomOnMouseWheel: false,
      //               // moveOnMouseMove: false,
      //               // filterMode: 'filter',
      //               // brushSelect: false,
      //               // zoomLock: false
      //             }
      //           ],

      dataZoom: [
        //      {
        //   show: true,
        //   realtime: true,
        //   start: 0,
        //   //  left: 50, //左边的距离
        //   //     right: 40, //右边的距离
        //       bottom: 40, //右边的距离
        //          height: 14, //组件高度
        //   xAxisIndex: [0],
        //   handleColor: "#ddd", //h滑动图标的颜色
        //       handleStyle: {
        //         borderColor: "#cacaca",
        //         borderWidth: "1",
        //         shadowBlur: 2,
        //         background: "#ddd",
        //         shadowColor: "#ddd",
        //       },
        // },
        // {
        //   type: 'inside',
        //   realtime: true,
        //   start:0,
        //   disabled: true,
        // },
        //给x轴设置滚动条
        {
          start: 0, //默认为0
          // end: 100 - 1500 / 31, //默认为100
          type: "slider",
          yAxisIndex: "false",
          show: true,
          xAxisIndex: [0],
          // handleSize: 0, //滑动条的 左右2个滑动条的大小
          height: 14, //组件高度
          // left: 50, //左边的距离
          // right: 40, //右边的距离
          bottom: 40, //右边的距离
          handleColor: "#fff", //h滑动图标的颜色
          handleStyle: {
            borderColor: "#fff",
            borderWidth: "1",
            shadowBlur: 40,
            background: "#fff",
            shadowColor: "#fff",
          },
          fillerColor: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            {
              //给颜色设置渐变色 前面4个参数，给第一个设置1，第四个设置0 ，就是水平渐变
              //给第一个设置0，第四个设置1，就是垂直渐变
              offset: 0,
              color: "#fff",
            },
            {
              offset: 1,
              color: "#fff",
            },
          ]),
          backgroundColor: "rgba(110, 110, 110)", //两边未选中的滑动条区域的颜色
          showDataShadow: false, //是否显示数据阴影 默认auto
          // showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
          // handleIcon:
          //   "M-292,322.2c-3.2,0-6.4-0.6-9.3-1.9c-2.9-1.2-5.4-2.9-7.6-5.1s-3.9-4.8-5.1-7.6c-1.3-3-1.9-6.1-1.9-9.3c0-3.2,0.6-6.4,1.9-9.3c1.2-2.9,2.9-5.4,5.1-7.6s4.8-3.9,7.6-5.1c3-1.3,6.1-1.9,9.3-1.9c3.2,0,6.4,0.6,9.3,1.9c2.9,1.2,5.4,2.9,7.6,5.1s3.9,4.8,5.1,7.6c1.3,3,1.9,6.1,1.9,9.3c0,3.2-0.6,6.4-1.9,9.3c-1.2,2.9-2.9,5.4-5.1,7.6s-4.8,3.9-7.6,5.1C-285.6,321.5-288.8,322.2-292,322.2z",
          filterMode: "filter",
        },
        //下面这个属性是里面拖到
        {
          type: "inside",
          show: true,
          xAxisIndex: [0],
          // zoomLock: false,
          disabled: true, // 禁用鼠标滚动缩放
          //  start: 0,//默认为1
          //  end: 100-1500/31,//默认为100
        },
      ],
      xAxis: {
        type: "category",
        boundaryGap: false,
        data: this.details_data.rows?.timeline,
      },

      series: newSeries,
    };

    myChart.setOption(option);

    myChart.getZr().on("click", (params) => {
      this.childrenListArray = [];

      var pointInPixel = [params.offsetX, params.offsetY];
      if (myChart.containPixel("grid", pointInPixel)) {
        /*此处添加具体执行代码*/
        (this.loading = true), (this.tableList = []);

        var pointInGrid = myChart.convertFromPixel(
          { seriesIndex: 0 },
          pointInPixel
        );
        //X轴序号
        var xIndex = pointInGrid[0];

        //获取当前图表的option
        var op = myChart.getOption();

        //获得图表中我们想要的数据
        var month = (op.xAxis as any)[0].data[xIndex];

        let indexFrame = this.details_data?.rows?.timeline.indexOf(month);

        this.frame = this.details_data?.rows?.Frame[indexFrame];
        let readerDeepData1: any = dispatchGetDeepPerformanceStack(store, {
          project: this.localProject,
          id_test: Number(this.id),
          frame: this.frame,
          level: 1,
          func_hash: "",
        });

        readerDeepData1.then((res: any) =>
          // console.log(res.func_list),

          {
            res.func_list.forEach(function (v: any, index: any) {
              v.id = index += 1;
            });
            this.tableList = res.func_list;
            this.loading = false;
          }
        );

        // if(arr[0]==arrayId){
        //   arr=[]
        //   this.b=arr
        // }
        // this.loading=false
      }
    });
  }
}
